import { render } from "./ReleaseNotesBanner.vue?vue&type=template&id=3378eb84&scoped=true"
import script from "./ReleaseNotesBanner.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesBanner.vue?vue&type=script&lang=js"

import "./ReleaseNotesBanner.vue?vue&type=style&index=0&id=3378eb84&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3378eb84"]])

export default __exports__